import { CrossIcon } from 'components/Icon/SVGIcons';
import { VideoThumbnail } from 'components/VideoThumbnail';
import React from 'react';
import Modal from 'react-responsive-modal';
import { colorsV2 } from 'style/colors-v2';

export const VideoModal = ({
  url = '',
  isOpened,
  onClose,
  videoType = 'video/mp4'
}) => {
  const isYoutube = url.includes('youtube.com') || url.includes('youtu.be');

  const videoSource = isYoutube
    ? {
        provider: 'youtube',
        src: url
      }
    : {
        type: videoType,
        src: url
      };

  const source = {
    type: 'video',
    sources: [videoSource]
  };

  return (
    <Modal
      open={isOpened}
      onClose={onClose}
      closeIcon={<CrossIcon withBackground={false} />}
      blockScroll={false}
      styles={{
        overlay: {
          padding: 0,
          zIndex: 200000
        },
        modal: {
          backgroundColor: colorsV2.neutral200,
          width: '100%',
          height: '100%',
          maxWidth: '100%',
          paddingTop: 70,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        },
        closeButton: {
          width: 40,
          height: 40,
          borderRadius: '50%',
          backgroundColor: 'rgba(0, 0, 0, 0.2)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          svg: {
            display: 'block'
          }
        }
      }}
    >
      <VideoThumbnail
        playInline
        width={1000}
        plyrSource={source}
        plyrOptions={{
          autoplay: true
        }}
      />
    </Modal>
  );
};
